import { useTrackedProjects } from "in_queue/contexts/ProjectDataContext";

export const useIsProjectNameAvailable = ({
    name,
    subscriptionId,
    currentProjectId
}: {
    name: string;
    subscriptionId: string | undefined;
    currentProjectId?: string;
}): boolean => {
    const trackedProjects = useTrackedProjects();
    const trimmed = name.trim().toLowerCase();
    if (trimmed === "") {
        return true;
    }
    if (!subscriptionId || trackedProjects === "loading") {
        return true;
    }

    // we require projectNames to be unique within a subscription
    return !trackedProjects.some(
        (p) =>
            p.subscriptionId === subscriptionId &&
            p.projectId !== currentProjectId &&
            p.projectName?.toLowerCase() === trimmed
    );
};
